import CustomButton from '../../../common/components/CustomButton';
import CustomRadio from '../../../common/components/CustomRadio';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeModificationFormView1FieldName = 'reason';

/**
 * 選択画面
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeModificationFormView1({
  getValue,
  setValue,
  getErrors,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView1FieldName) => string,
  setValue: (name: KaraokeModificationFormView1FieldName, value: string) => void,
  getErrors: (name: KaraokeModificationFormView1FieldName) => FieldValidationErrorsType,
  onNext: () => void,
}) {
  const options = [
    { value: 'modification', title: 'お客様都合', description: '提出時に間違った、後から変更することになった場合など' },
    { value: 'correction', title: 'Frekulの過失', description: '提出内容と違う形で配信されている、テロップの表示タイミングに違和感がある場合など' },
  ];

  return (
    <div className="form__body">
      <dl>
        <dt>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label>修正理由</label>
        </dt>
        <dd>
          <CustomRadio
            options={options}
            value={getValue('reason')}
            setValue={(value) => setValue('reason', value)}
            validationErrors={getErrors('reason')}
          />
        </dd>
      </dl>
      <p className="top_line" />
      <ul>
        <li className="bt">
          <CustomButton type="default" onClick={() => onNext()}>次へ</CustomButton>
        </li>
      </ul>
    </div>
  );
}
